import { DialogTitle, Typography, useTheme } from "@mui/material"
import { FC } from "react"
import { StyledButton, StyledDialog, StyledDialogActions, StyledDialogContent } from "../../forms/inputs/CommonFormElements"

interface IConfirmRemovePointsDialogProps {
    open: boolean,
    onConfirm: () => void,
    onClose: () => void
}

const ConfirmRemovePointsDialog: FC<IConfirmRemovePointsDialogProps> = ({
    open,
    onConfirm,
    onClose
}) => {
    const theme = useTheme();

    return (
        <StyledDialog 
            maxWidth="xs"
            onClose={() => {
                throw new Error("Function not implemented.")
            }} 
            open={open}
        >
            <DialogTitle
                sx={{
                    backgroundColor: theme.palette.secondary.light,
                    color: "white"
                }}
            >
                Clear Points
            </DialogTitle>
            <StyledDialogContent>
                <Typography>
                    Are you sure you want to clear all points? This cannot be undone.
                </Typography>
            </StyledDialogContent>
            <StyledDialogActions>
                <StyledButton
                    variant="contained"
                    onClick={() => {
                        onConfirm();
                        onClose();
                    }}
                >
                    Confirm
                </StyledButton>
                <StyledButton
                    variant="contained"
                    onClick={onClose}
                >
                    Cancel
                </StyledButton>
            </StyledDialogActions>
        </StyledDialog>
    )
}

export default ConfirmRemovePointsDialog;